module.exports = __webpack_public_path__ + "assets/adf805d88d4c7cc8ee9b84e72b1b9694.woff2";